import React from "react";
import { InputLabel, MenuItem, Select } from "@material-ui/core";
import { Currencies } from "../../data";
var CurrencySelect = function (props) {
    var options = Currencies.map(function (c) { return (React.createElement(MenuItem, { key: c, value: c }, c)); });
    return (React.createElement("div", { className: "col s12 m6" },
        React.createElement(InputLabel, null, "Currency"),
        React.createElement(Select, { className: "select", placeholder: "Currency", name: "currency", onChange: props.onChange, value: props.value, disabled: props.disabled }, options),
        React.createElement("div", { className: "red-text", style: { marginBottom: "20px" } }, props.meta && props.meta.touched && props.meta.error)));
};
export default CurrencySelect;



//////////////////
// WEBPACK FOOTER
// ./src/components/common/CurrencySelect.tsx
// module id = 1277
// module chunks = 0